<template>
  <!-- Sidebar -->
  <div class="nav-container">
    <!--el los usuarios que tienen representados ,el linck de inicio no se muestra hasta que seleccionar a quien representar-->
    <div style="width: 100%; height: 100%">
      <div class="ecologo">
        <img src="./../../assets/images/LuqueEcoLogo.svg" alt="" />
      </div>

      <div class="navUser">
        <router-link v-show="setPermission" :to="`/home`" class="bn3 inicio">
          <h2 class="h2-hero">Inicio</h2>
        </router-link>
        <router-link v-show="setPermission" :to="`/turnos`" class="bn3 turnos">
          <h2 class="h2-hero">Turnos</h2>
        </router-link>

        <router-link
          v-show="setPermission"
          :to="`/tramites`"
          class="bn3 tramites"
        >
          <h2 class="h2-hero">Trámites</h2>
        </router-link>

        <router-link
          v-show="setPermission"
          :to="`/documentos`"
          class="bn3 documentos"
        >
          <h2 class="h2-hero">Documentos</h2>
        </router-link>
        <router-link
          v-show="setPermission"
          :to="`/notificaciones`"
          class="bn3 notificaciones"
        >
          <h2 class="h2-hero">Notificaciones</h2>
        </router-link>

        <router-link
          v-show="setPermission"
          :to="`/representaciones`"
          class="bn3 representaciones"
          v-if="!this.$store.state.representative"
        >
          <h2 class="h2-hero">Representaciones</h2>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "@/env";
import store from "@/store";

export default {
  name: "NavComponent",
  data() {
    return {
      ruta: this.$router.currentRoute.value.fullPath,
      report: "",
      sendR: false,
      representante: store.state.representative,
      nivel: store.state.user?.level?.level,
    };
  },
  created() {},
  watch: {},
  computed: {
    setPermission() {
      if (this.$store.state.loggedIn === true) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    //METODO PARA ENVIAR UN REPORTE DE ERROR O FALLA EN EL SISTEMA
    sendReport() {
      // console.log(this.report, "soy el reporte");
      const apiClient = axios.create({
        baseURL: BASE_URL,
        withCredentials: false,
        headers: {
          "auth-header": localStorage.getItem("token"),
        },
      });
      apiClient
        .post("/feedback/bug-report/user", {
          report: this.report,
        })
        .then((response) => {
          // console.log(response);
          // this.message = response.data.message;
          if (response.status === 201) {
            this.sendR = true;
          }
          this.report = "";
        })
        .catch((error) => {
          this.msj = error.response.data.message;

          // console.log(error.data);
        });
    },
  },
};
</script>

<style scoped>
/* CSS NUEVO */
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0px;
  color: #fff;
}
.nav-container {
  position: fixed;
  margin-top: 12.521vh;
  display: flex;
  flex-direction: row;
  height: 100vh;
  z-index: 1;
  padding: 6.678vh 1.537vw;
  width: var(--widthNav);
  box-shadow: 4px 0px 30px 0px rgba(0, 0, 0, 0.1);
}
.ecologo {
  margin: auto;
  margin-bottom: 6.678vh;
  /* height: 16.694vh; */
  /* width: 7.32vw; */
  background-repeat: no-repeat;
  background-position: center;
  -o-object-fit: contain;
  object-fit: contain;
  display: flex;
  justify-content: center;
}

.ecologo img {
  height: 16.694vh;
  width: 7.32vw;
  transition:
    transform 0.25s ease,
    filter 0.25s ease;
}

.ecologo img:hover {
  transform: scale(1.05);
  filter: brightness(1.08);
}

.navUser {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2.17vh;
  height: 50.083vh;
}
.bn3 {
  height: 6.678vh;
  width: 13.9vw;
  text-align: center;
  border-radius: 1.25rem;
  border-style: none;
  align-content: center;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  padding: 1.669vh 0;
  transition: transform 0.2s ease;
}
.bn3:hover {
  transform: translateY(-2px);
}

.bn3:active {
  transform: translateY(1px);
}

a {
  text-decoration: none;
}

[data-theme="light"] .bn3.inicio {
  background: linear-gradient(180deg, #808080 50%, #404043 150%);
}

[data-theme="light"] .bn3.turnos {
  background: linear-gradient(180deg, #808080 40%, #404043 140%);
}

[data-theme="light"] .bn3.tramites {
  background: linear-gradient(180deg, #808080 30%, #404043 130%);
}

[data-theme="light"] .bn3.documentos {
  background: linear-gradient(180deg, #808080 20%, #404043 120%);
}

[data-theme="light"] .bn3.notificaciones {
  background: linear-gradient(180deg, #808080 10%, #404043 110%);
}

[data-theme="light"] .bn3.representaciones {
  background: linear-gradient(180deg, #808080 0%, #404043 100%);
}

/* MODO DARK */
[data-theme="dark"] .bn3.inicio,
.bn3.turnos,
.bn3.tramites,
.bn3.documentos,
.bn3.notificaciones,
.bn3.representaciones {
  background: var(--dark);
}
/* ----------------------------------------------- */

@media (max-width: 1360px) {
}

@media (max-width: 990px) {
  .nav-container {
    display: none;
  }
}
</style>
